import { DataStructure } from '../../domain/structure/DataStructureDomains';
import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { StructActions } from '../actions/StructActions';

export interface StructState {
  struct: DataStructure;
  isUpdate: boolean;
  preview: Record<string, any>;
  isDirty: boolean;
}

const initialState: StructState = {
  struct: ValueFactory.initializeDataStructure(),
  isUpdate: false,
  preview: {},
  isDirty: false,
};

export const structReducer = (state = initialState, action: ReduxBaseAction<any, StructActions>) => {
  switch (action.type) {
    case 'CHANGE_DATA_STRUCT':
      return { ...state, struct: action.payload, isDirty: true };
    case 'CHANGE_STRUCT_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_STRUCT':
      return { ...state, struct: ValueFactory.initializeDataStructure(), isUpdate: false, isDirty: false };
    case 'CHANGE_STRUCT_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
